// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p1-5";
export var filledCircle = "_p1-4";
export var historyEntry = "_p1-3";
export var messageSideLeft = "_p1-1";
export var messageSideRight = "_p1-2";
export var orderTrackingCarouselWrapper = "_p1-6";
export var orderTrackingInfoContainer = "_p1-0";